import { Marquee } from "@/components/kit";

const verticals = [
  "B2B SaaS",
  "Cybersecurity",
  "Fintech",
  "DevTools",
  "AI / ML",
  "Data Infrastructure",
  "MarTech",
  "HR Tech",
  "Cloud & Infra",
  "Vertical SaaS",
];

export const TechMarquee = () => (
  <div
    data-testid="tech-marquee"
    className="relative border-y border-white/10 bg-navy-800/40 py-7 md:py-9"
  >
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 md:w-40 bg-gradient-to-r from-navy-900 to-transparent z-10" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 md:w-40 bg-gradient-to-l from-navy-900 to-transparent z-10" />
    <Marquee
      items={verticals}
      itemClassName="font-display text-xl md:text-3xl font-medium uppercase tracking-tight text-white/40"
    />
  </div>
);
